<template>
  <base-dialog
    ref="dialog"
    :title="$t('message.confirm')"
    :message="'現在、編集中の情報が破棄されますがよろしいでしょうか？'"
    :cancel-text="$t('message.no')"
    :submit-text="$t('message.yes')"
    max-width="350"
    @submit="submit()"
  />
</template>

<script>
export default {
  methods: {
    open() {
      this.$refs.dialog.open()
    },
    close() {
      this.$refs.dialog.close()
    },
    submit() {
      this.$emit('submit')
      this.close()
    },
  },
}
</script>
